import { Vue, Component } from "vue-property-decorator";
import AI from "@/services/ApplicationInsights";
import moment from "moment";
import { BreadCrumb, globalStore } from "@/store/modules/GlobalStore";
import { Pages } from "@/enums/Pages";
import TextField from "@/components/TextField.vue";
import TextFieldWithMask from "@/components/TextFieldWithMask.vue";
import Rules from "@/code/ValidationRules";

@Component({
  components: {
    TextField,
    TextFieldWithMask,
  },
})
export default class BasePage extends Vue {
  page: Pages | null = null;
  isFormValid = false;
  moment = moment;
  title = "";
  breadCrumbs: BreadCrumb[] = [];
  validationRules = Rules;

  mounted(): void {
    if (this.page) {
      console.log(`Tracking Page View: ${this.page}`);
      AI.pageView(this.page);
    }
    globalStore.setBreadCrumbs(this.breadCrumbs);
    globalStore.setTitle(this.title);
  }

  get saveButtonEnabled(): boolean {
    return this.isFormValid;
  }
}
